module.exports = __webpack_public_path__ + "static/media/page_background_sec_web_large.248c0860.svg";